import { render } from "./missed-messages.vue?vue&type=template&id=07e9b09d&lang=pug"
import script from "./missed-messages.vue?vue&type=script&setup=true&lang=js"
export * from "./missed-messages.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__